import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom';
import { Navbar, Nav } from 'react-bootstrap';
import { Cloud } from 'react-bootstrap-icons';
import AppFooter from './AppFooter';
import { PageSkeleton } from './components/Skeletons';
import './App.css';

// Lazy-loaded route components for better initial bundle size
const Home = lazy(() => import('./Home'));
const Timelapse = lazy(() => import('./Timelapse'));
const Forecast48 = lazy(() => import('./Forecast48'));
const WildfireHistory = lazy(() => import('./WildfireHistory'));
const ReadySetGo = lazy(() => import('./ReadySetGo'));
const SacatonFire = lazy(() => import('./SacatonFire'));

function App() {
  return (
    <>
      <BrowserRouter>
        <Navbar bg="dark" variant="dark" collapseOnSelect expand="md">
          <Navbar.Brand href="/">
            <Cloud aria-hidden="true" /> Willow Creek WX
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            aria-label="Toggle navigation menu"
          />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mr-auto" aria-label="Main navigation">
              <Nav.Link as={NavLink} to="/">
                Home
              </Nav.Link>
              <Nav.Link as={NavLink} to="/timelapses">
                Time-lapse
              </Nav.Link>
              <Nav.Link as={NavLink} to="/forecast">
                48-Hour Forecast
              </Nav.Link>
              <Nav.Link as={NavLink} to="/wildfires">
                Wildfires
              </Nav.Link>
              <Nav.Link as={NavLink} to="/ready-set-go">
                Ready/Set/Go
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <Suspense fallback={<PageSkeleton />}>
          <Routes>
            <Route path="/forecast" element={<Forecast48 />} />
            <Route path="/ready-set-go" element={<ReadySetGo />} />
            <Route path="/wildfires/2026-sacaton" element={<SacatonFire />} />
            <Route path="/wildfires" element={<WildfireHistory />} />
            <Route path="/timelapses/:id/" element={<Timelapse />} />
            <Route path="/timelapses" element={<Timelapse />} />
            <Route path="/" element={<Home />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <AppFooter />
    </>
  );
}

export default App;
